import BaseTableController from './base_table_controller';

const UNIT_OPTIONS = ['kilograms (kg)', 'metric tonnes (t)', 'cubic meters (m3)'];

// dp_id 2444 — data_grid: { rows: [{ waste_type, unit_of_measurement, diverted_to_recycle, directed_to_disposal, amount }] }
export default class extends BaseTableController {
  static values = { wasteTypeOptions: Array };

  searchableFields = ['waste_type', 'unit_of_measurement'];

  connect() {
    const rows = this.initialDataValue?.rows;
    this.rows =
      Array.isArray(rows) && rows.length > 0
        ? rows.map((r) => ({
            waste_type: r.waste_type ?? '',
            unit_of_measurement: r.unit_of_measurement ?? '',
            diverted_to_recycle: r.diverted_to_recycle ?? null,
            directed_to_disposal: r.directed_to_disposal ?? null,
            amount: r.amount ?? null,
          }))
        : [this.emptyRow()];
    this.renderRows();
    this.syncHiddenField();
  }

  emptyRow() {
    return {
      waste_type: '',
      unit_of_measurement: '',
      diverted_to_recycle: null,
      directed_to_disposal: null,
      amount: null,
    };
  }

  updateField(event) {
    const el = event.currentTarget;
    const index = parseInt(el.dataset.rowIndex, 10);
    const field = el.dataset.field;
    this.rows[index][field] =
      el.type === 'number' ? (el.value === '' ? null : parseInt(el.value, 10)) : el.value;
    this.recalculateAmount(index);
    this.syncHiddenField();
  }

  recalculateAmount(index) {
    const row = this.rows[index];
    const toInt = (v) => {
      const n = parseInt(v, 10);
      return isNaN(n) ? null : n;
    };
    const a = toInt(row.diverted_to_recycle);
    const b = toInt(row.directed_to_disposal);
    row.amount = a !== null || b !== null ? (a === null ? 0 : a) + (b === null ? 0 : b) : null;
    const amountInput = this.tableBodyTarget.querySelectorAll('input[data-field="amount"]')[index];
    if (amountInput) amountInput.value = row.amount !== null ? row.amount : '';
  }

  buildRow(row, index) {
    const tr = document.createElement('tr');

    tr.appendChild(this.buildSelectCell(row, index, 'waste_type', this.wasteTypeOptionsValue));
    tr.appendChild(this.buildSelectCell(row, index, 'unit_of_measurement', UNIT_OPTIONS));
    tr.appendChild(this.buildIntegerCell(row, index, 'diverted_to_recycle'));
    tr.appendChild(this.buildIntegerCell(row, index, 'directed_to_disposal'));

    const amountTd = document.createElement('td');
    const amountInput = document.createElement('input');
    amountInput.type = 'number';
    amountInput.readOnly = true;
    amountInput.className = 'form-control w-100';
    amountInput.dataset.rowIndex = index;
    amountInput.dataset.field = 'amount';
    if (row.amount !== null && row.amount !== undefined) amountInput.value = row.amount;
    amountTd.appendChild(amountInput);
    tr.appendChild(amountTd);

    tr.appendChild(this.buildRemoveButton(index));

    return tr;
  }

  buildIntegerCell(row, index, field) {
    const td = document.createElement('td');
    const input = document.createElement('input');
    input.type = 'number';
    input.min = '0';
    input.step = '1';
    input.placeholder = '0';
    input.className = 'form-control w-100';
    input.dataset.rowIndex = index;
    input.dataset.field = field;
    input.addEventListener('input', (e) => this.updateField(e));
    if (row[field] !== null && row[field] !== undefined) input.value = row[field];
    td.appendChild(input);
    return td;
  }
}
